import { useCurrentCareRegion } from '~/hooks/useCurrentCareRegion';
import useSelectActiveUserProfile from '~/hooks/useSelectActiveUserProfile';
import { centsToCurrencyStr } from '~/core/util/currency';

export type USState = 'TX' | 'NY' | 'NJ';

export type PriceTiers = { low: number; medium: number; high: number };

export const inPersonPlusPrices: Record<USState, PriceTiers> = {
  TX: {
    low: 99,
    medium: 125,
    high: 150,
  },
  NJ: {
    low: 110,
    medium: 125,
    high: 150,
  },
  NY: { low: 110, medium: 125, high: 150 },
};

/**
 * Returns the price for the in-person plus membership in either
 * the current care region or for a specific state code passted in.
 *
 * @returns The pricing object for that region
 */
export default function useInPersonPlusPricing(overrideRegionStateCode?: USState) {
  const careRegionStateCode = useCurrentCareRegion(useSelectActiveUserProfile()?.user_profile_id);
  const region = overrideRegionStateCode ?? careRegionStateCode ?? 'NJ';

  if (region.toUpperCase() === 'TX') {
    return inPersonPlusPrices.TX;
  }

  return inPersonPlusPrices.NJ;
}

export function useInPersonPlusPriceRangeStr(overrideRegionStateCode?: USState) {
  const priceTiers: any = useInPersonPlusPricing(overrideRegionStateCode);

  return `${centsToCurrencyStr(priceTiers.low * 100)}\u2013${centsToCurrencyStr(
    priceTiers.high * 100
  )}`;
}
